/**
 * Un importe de la compra en $ y en Bs (documento de la dueña del 26-10-2026: «los montos totales no me salen en Bs;
 * necesito saber si coinciden con el físico de la factura»). Los Bs son los fiscales guardados con la compra (los del
 * libro y el comprobante); si la factura vino en Bs, los Bs van primero y en negrita.
 * `testid` marca siempre los $ (como antes) y `testid-bs` los Bs.
 */
import { Money } from '@mg/shared';

export function MontoCompra({ usd, bs, enBs, signo = '', testid }: { usd: string; bs: string; enBs: boolean; signo?: '' | '−'; testid?: string }) {
  const dolares = <span className={enBs ? 'text-xs font-normal text-muted-foreground' : 'font-bold'} data-testid={testid}>{signo}$ {Money.parse(usd).toDisplay()}</span>;
  const bolivares = <span className={enBs ? 'font-bold' : 'text-xs font-normal text-muted-foreground'} data-testid={testid ? `${testid}-bs` : undefined}>{signo}Bs {Money.parse(bs).toDisplay()}</span>;
  return <span className="num text-right">{enBs ? <>{bolivares} {dolares}</> : <>{dolares} {bolivares}</>}</span>;
}

/** Neto por pagar en Bs: el total de la factura menos lo retenido (la misma cuenta del neto en $). */
export const netoBs = (t: { total_factura_bs: string; retencion_iva_bs: string; retencion_islr_bs: string }) => Money.parse(t.total_factura_bs).sub(t.retencion_iva_bs).sub(t.retencion_islr_bs).toDocumento();
